import type { BoggleBadgeCheck } from '../checkTypes'
import { isAcceptedWordEntry } from '../checkTypes'

export const spellingBeeCheck: BoggleBadgeCheck = (ledger, index) => {
  const entry = ledger[index]
  return (
    isAcceptedWordEntry(entry) &&
    entry.word.length >= 7 &&
    entry.formedWithoutBackspace
  )
}
